/* SearchDropdownOverlay.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["mobileVisibility"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "@media (min-width:64rem){._1yagtz5q{padding:var(--ds-space-200,1pc) var(--ds-space-250,20px) var(--ds-space-150,9pt) var(--ds-space-300,24px)}}";
const _10 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _9 = "._4cvr1h6o{align-items:center}";
const _8 = "._1e0c1txw{display:flex}";
const _7 = "._1bsb1osq{width:100%}";
const _6 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _5 = "._1yt4cjm9{padding:var(--ds-space-200,1pc) var(--ds-space-200,1pc) var(--ds-space-150,9pt) 0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { useHistory, useLocationHref, useQueryParams } from '@atlassian/mpac-ui';
import { useMountPath, useSource } from '@atlassian/mpac-utils';
import React, { useCallback, useEffect, useRef } from 'react';
import { useAlgoliaAutocomplete } from '../../AlgoliaClientSDK/useAlgoliaAutocomplete';
import { getSuggestionSource } from '../../AnalyticsUtils';
import { desktopPlaceholder, mobilePlaceholder } from '../../constants';
import { RecentSearch } from '../../SearchUtils';
import { redirectToNewQuery } from '../../SearchUtils/search-navigation-utils/SearchNavigationUtils';
import { SearchBodyFactory } from '../SearchBodyFactory';
import { SearchFooter } from '../SearchFooter';
import { SearchHeader } from '../SearchHeader';
import { useAutocompleteState } from './hooks/useAutocompleteState';
import { useSearchDropdown } from './hooks/useSearchDropdown';
import { useSearchViewAnalytics } from './hooks/useSearchViewAnalytics';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _4 = "._1e0cglyw{display:none}";
const _3 = "._1e0c1ule{display:block}";
const _2 = "@media (min-width:64rem){._dm251ule{display:block}}";
const _ = "._n7zl1yb9{border-bottom:var(--_szw93i)}";
const Separator = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      mobileVisibility
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_szw93i": ix("".concat(__cmplp.height, "px solid ", "var(--ds-border, #091E4224)"))
      }),
      ref: __cmplr,
      className: ax(["_n7zl1yb9 _dm251ule", __cmplp.mobileVisibility ? "_1e0c1ule" : "_1e0cglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Separator.displayName = 'Separator';
}
const Header = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4cjm9 _zulpu2gc _1bsb1osq _1e0c1txw _4cvr1h6o _syaz131l _1yagtz5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
// RECENT SEARCH HANDLINGS
const recentSearch = new RecentSearch(5, 'mpac-search-recent-searches');

// eslint-disable-next-line max-lines-per-function
export function SearchDropdownOverlay(_ref3) {
  let {
    closeOverlay,
    onViewed,
    onSuggestionSelection,
    onEnterKeyPress,
    backButtonRef,
    additionalQueryParams = {}
  } = _ref3;
  // LOCATION HANDLINGS
  const {
    query: queryFromUrl
  } = useQueryParams();
  const locationHref = useLocationHref();
  const history = useHistory();
  const source = useSource();
  const mountPath = useMountPath();

  // AUTOCOMPLETE HANDLINGS
  const inputRef = useRef(null);
  const searchSuggestionCountRef = useRef(0);
  const hasFiredViewedAnalyticsRef = useRef(false);
  const handleNewSearch = useCallback(hit => {
    var _inputRef$current, _hit$__autocomplete_i;
    const inputValue = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value;
    onSuggestionSelection({
      query: hit.query,
      position: ((_hit$__autocomplete_i = hit.__autocomplete_id) !== null && _hit$__autocomplete_i !== void 0 ? _hit$__autocomplete_i : 0) + 1,
      popularity: hit.popularity,
      suggestionSource: getSuggestionSource(!!inputValue),
      count: inputValue ? searchSuggestionCountRef.current : recentSearch.count()
    });
    recentSearch.push(hit);
    redirectToNewQuery({
      query: hit.query,
      locationHref,
      history,
      additionalQueryParams,
      source,
      mountPath
    });
    closeOverlay();
  }, [locationHref, history, closeOverlay, onSuggestionSelection]);
  const onFormSubmit = query => {
    handleEnterKeyPress(query);
    closeOverlay();
  };
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.md;
  const {
    autocomplete,
    autocompleteState
  } = useAlgoliaAutocomplete(inputRef, isMobile ? mobilePlaceholder : desktopPlaceholder, queryFromUrl, handleNewSearch, recentSearch);
  const {
    handleAppend,
    handleEnterKeyPress,
    clearRecentSearches,
    clearSearchInput
  } = useSearchDropdown({
    inputRef,
    autocomplete,
    autocompleteState,
    recentSearch,
    onEnterKeyPress,
    additionalQueryParams
  });

  // BODY STATE HANDLINGS
  const {
    bodyState
  } = useAutocompleteState({
    autocompleteState
  });
  const searchSuggestionProps = {
    hits: autocompleteState.collections,
    autocomplete,
    onAppend: handleAppend
  };
  useEffect(() => {
    var _autocompleteState$co, _autocompleteState$co2, _autocompleteState$co3;
    searchSuggestionCountRef.current = (_autocompleteState$co = (_autocompleteState$co2 = autocompleteState.collections[0]) === null || _autocompleteState$co2 === void 0 ? void 0 : (_autocompleteState$co3 = _autocompleteState$co2.items) === null || _autocompleteState$co3 === void 0 ? void 0 : _autocompleteState$co3.length) !== null && _autocompleteState$co !== void 0 ? _autocompleteState$co : 0;
  }, [bodyState, autocompleteState]);
  useEffect(() => {
    autocomplete.refresh();
  }, []);
  useSearchViewAnalytics({
    showSuggestionPopup: true,
    inputRef,
    isQueryFromUrl: !!queryFromUrl,
    onViewed,
    recentSearch,
    hasFiredViewedAnalyticsRef,
    autocompleteState,
    bodyState
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      children: /*#__PURE__*/_jsx(SearchHeader, {
        autocomplete: autocomplete,
        ref: inputRef,
        handleEnterKeyPress: onFormSubmit,
        handleBackClick: closeOverlay,
        clearSearchInput: clearSearchInput,
        isEmbedded: false,
        backButtonRef: backButtonRef
      })
    }), /*#__PURE__*/_jsx(Separator, {
      height: 2,
      mobileVisibility: true
    }), /*#__PURE__*/_jsx("div", {
      role: "status",
      "aria-live": "assertive",
      "aria-relevant": "additions",
      children: /*#__PURE__*/_jsx(SearchBodyFactory, {
        type: bodyState,
        searchQuerySuggestionsBodyProps: _objectSpread({
          query: autocompleteState.query
        }, searchSuggestionProps),
        searchLoadingProps: {
          query: autocompleteState.query
        },
        recentSearchBodyProps: _objectSpread({
          onClearAll: clearRecentSearches,
          closeOverlay
        }, searchSuggestionProps),
        noSuggestionsBodyProps: {
          query: autocompleteState.query
        }
      })
    }), /*#__PURE__*/_jsx(Separator, {
      height: 1,
      mobileVisibility: false
    }), /*#__PURE__*/_jsx(SearchFooter, {
      closeOverlay: closeOverlay
    })]
  });
}